// @flow
import {setBattleValue, setCombatantValue} from '../../redux-actions/battle-actions.js'
import {decodeSafeFirebaseRolloutStateChange} from '../connection/firebase-safe.js'
import store from '../../init/store.js'
import {handleRolloutStep} from './handle-new-rollout'
import {runEaseOut} from './run-ease-out'
import audioManager from '../../_audio/audio-manager.js'

export function handleStateChange(currentStep: Object) {

  const newCombatantState = currentStep.newCombatantState || {};
  const description = currentStep.description || {};

  //Fires when all graduals are completed (or no graduals are required)
  function completeStateChange() {
    //Firebase eats this if it's empty, so provide fallback empty object.
    Object.keys(newCombatantState || {}).forEach(combatantId => {
      //Convert "firebase safe" values back to actual falsy values that our app needs.
      //I know this is Firebase specific, but it's safe for the local-only play to run through also.
      const safeFirebaseState = decodeSafeFirebaseRolloutStateChange(newCombatantState[combatantId]);
      setCombatantValue(combatantId, {
        ...safeFirebaseState
      })
    });
    handleStateChangeFinished()
  }

  /** Skip the gradual stuff on Console and Reporting views */
  if (store.getState().battle.battleViewMode !== "arena") {
    completeStateChange();
    return;
  }

  //GRADUALS: //The only gradual change at the moment is HP values.

  //For each HP change, need to kick off a loop (check for graduals)
  if (description.hpDamage) {
    //Create required count and progress count
    let gradualHpChangeCountRequired = 0;
    let gradualHpChangeCountCompleted = 0;

    //Create HP Change loops for each affected combatant
    Object.keys(description.hpDamage).forEach(combatantId => {

      const change = description.hpDamage[combatantId];
      const wasValue = newCombatantState[combatantId].hp - change; //Supply the original "was" value (new value with offset change);

      //Check that this state change has not been executed already
      //Some moves run "stateChanges" throughout the rollout. If our state has already been rectified, we don't want to re-run these gradual changes.
      //The end result would be the same, but you'd see the blinking and health bars depleting twice. (ending at the same point)
      //...
      //Verify that state has not changed yet, and we need to see the gradual animation

      // TODO I'm having a hard time wrapping my head around these values after coming back from awhile, but the redux value being negative is causing the GradualHpChange to not be created.
      //Floor this value at 0. If it's negative, it causes the animation to not fire.
      let useHpValueFromReduxState = store.getState().battle.combatants[combatantId].hp;
      if (useHpValueFromReduxState < 0) { useHpValueFromReduxState = 0 }

      //Create an HP Change if the current state value is still the wasValue. This means it hasn't transitioned to the new value.
      if (useHpValueFromReduxState === wasValue) {

        gradualHpChangeCountRequired++; //Increment the number of graduals we're waiting for

        //Create a gradual HP change and wait for it to finish
        new GradualHpChange(combatantId, () => {
          //Gradual change completed!
          //increment number of completed graduals
          gradualHpChangeCountCompleted++;

          //Check if we are through with all graduals
          if (gradualHpChangeCountCompleted >= gradualHpChangeCountRequired) {
            completeStateChange();
          }
        }, wasValue, change)
      }
    });

    //In the case that all state changes have already been displayed, we might be waiting on 0 graduals, so just move on
    if (gradualHpChangeCountRequired === 0) {
      //console.log('not waiting on any Gradual changes')
      completeStateChange();
    }

  } else {
    //Not waiting on any graduals, so just go directly to conclusion
    completeStateChange();
  }
}


function GradualHpChange(combatantId: string, callback: Function, oldValue: number, change: number) {

  //Start blinking the combatant if HP change is negative
  if (change < 0) {

    //Play sound!
    audioManager.playSfx("sfx_Babuhm")

    setCombatantValue(combatantId, {
      animationCssRule: "blink 0.3s steps(2, start) infinite"
    });
  }

  function handleIteration(newValue) {
    // console.log(newValue, combatantId);
    setCombatantValue(combatantId, {
      hp: newValue
    })
  }

  //Run the easing loop, then fire callback and remove blinking animation
  runEaseOut(oldValue, change, 100, handleIteration, () => {
    setCombatantValue(combatantId, {
      animationCssRule: "none"
    });
    callback();
  })
}







function handleStateChangeFinished() {
  setBattleValue({
    rolloutExecutingIndex: store.getState().battle.rolloutExecutingIndex + 1
  });
  handleRolloutStep(); //move on to the next step
}


// WEBPACK FOOTER //
// ./src/battle/lifecycle/handle-state-change.js